<template>
  <div>
    <pop-in
      :text="textGlobalOpposition" validation-input="Je confirme mon opposition"
      @close-modal="$emit('close-modal')" @validation="$emit('validation'); $emit('close-modal')"
    />
  </div>
</template>

<script>
import PopIn from "@/components/PopIn";
export default {
  name: 'PopInGlobalOpposition',
  components: {PopIn},
  data() {
    return {
      textGlobalOpposition: {}
    };
  },

  created() {
    this.textGlobalOpposition.content = "En application de l’article 56 de la Loi Informatique et Libertés, " +
        "vous allez vous opposer à ce que des données à caractère personnel vous concernant ou concernant la personne " +
        "pour laquelle vous agissez en tant que représentant légal fassent l'objet de traitements automatisés ayant pour " +
        "finalité la recherche.\n" + "\n" + "Ceci ne changera en rien en rien la qualité des soins qui seront prodigués à " +
        "vous ou  la personne pour laquelle vous agissez en tant que représentant légal.";

    this.textGlobalOpposition.confirmMessage = "Pour confirmer ce choix entrer “Je confirme mon opposition“ ci-dessous";
    this.textGlobalOpposition.validation = "Confirmer mon opposition";
  }
};
</script>